import React from 'react';
import { Company } from '../../../../../types/company';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { Collapsable } from '../../../Collapsable';
import { FeatureToggleItem, FeatureToggleTitle, FeatureToggleExplanation, FeatureToggleInformation } from '../common';

interface ScanFeatureTogglesViewProps {
  company: Company;
  update: (company: Company) => Promise<void>;
}

export default function ScanFeatureTogglesView({ company, update }: ScanFeatureTogglesViewProps) {
  const copy = new Company(company);
  const toggles = copy.settings.featureToggles.scan;

  return (
    <Collapsable
      open={true}
      header={
        <FeatureToggleItem value={true} onChange={async value => {}}>
          <FeatureToggleTitle text={t(TranslationKey.scanFeatureToggleTitle).singular.upper} />
          <FeatureToggleExplanation text={t(TranslationKey.scanFeatureToggleExplanation).singular.upper} />
          <FeatureToggleInformation text={t(TranslationKey.scanFeatureToggleInformation).singular.upper} />
        </FeatureToggleItem>
      }
    >
      <FeatureToggleItem
        indent={1}
        value={toggles.handleGS1ProductNumberSeparately}
        onChange={async value => await update(copy.withScanHandleGS1ProductNumberSeparately(value))}
      >
        <FeatureToggleTitle
          text={t(TranslationKey.scanHandleGS1ProductNumberSeparatelyFeatureToggleTitle).singular.upper}
        />
        <FeatureToggleExplanation
          text={t(TranslationKey.scanHandleGS1ProductNumberSeparatelyFeatureToggleExplanation).singular.upper}
        />
      </FeatureToggleItem>

      <FeatureToggleItem
        indent={1}
        value={toggles.handleGS1LotSeparately}
        onChange={async value => await update(copy.withScanHandleGS1LotSeparately(value))}
      >
        <FeatureToggleTitle text={t(TranslationKey.scanHandleGS1LotSeparatelyFeatureToggleTitle).singular.upper} />
        <FeatureToggleExplanation
          text={t(TranslationKey.scanHandleGS1LotSeparatelyFeatureToggleExplanation).singular.upper}
        />
      </FeatureToggleItem>

      <FeatureToggleItem
        indent={1}
        value={toggles.ignoreGS1Lot}
        onChange={async value => await update(copy.withScanIgnoreGS1Lot(value))}
      >
        <FeatureToggleTitle text={t(TranslationKey.scanIgnoreGS1LotFeatureToggleTitle).singular.upper} />
        <FeatureToggleExplanation text={t(TranslationKey.scanIgnoreGS1LotFeatureToggleExplanation).singular.upper} />
      </FeatureToggleItem>
    </Collapsable>
  );
}
